import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "6px 24px",
          fontWeight: 500,
          textTransform: "none",
          boxShadow: "none",
          transition: "all 0.2s ease",
        },

        contained: {
          backgroundColor: "#5E22F3",
          color: "#fff",

          "&:hover": {
            backgroundColor: "#5b4fe8",
          },
        },

        outlined: {
          borderColor: "#5E22F3",
          color: "#5E22F3",

          "&:hover": {
            borderColor: "#5b4fe8",
            backgroundColor: "#f5f3ff",
          },
        },

        text: {
          color: "#5E22F3",

          "&:hover": {
            backgroundColor: "#eef2ff",
          },
        },
      },
    },
  },
});